import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Paper, Title, Text, SimpleGrid, Group, Anchor, Stack, Center } from "@mantine/core";
import { PageLoader } from "@/components/common";
import { ApartmentGrid } from "@/components/apartments";
import { apartmentsApi } from "@/api/client";

export const Route = createFileRoute("/_authenticated/")({
  component: DashboardPage,
});

function DashboardPage() {
  const { data: stats, isLoading: statsLoading } = useQuery({
    queryKey: ["apartments", "stats"],
    queryFn: apartmentsApi.getStats,
  });

  const { data: apartmentsData, isLoading: apartmentsLoading } = useQuery({
    queryKey: ["apartments", { limit: 6 }],
    queryFn: () => apartmentsApi.list({ page_size: 6 }),
  });

  if (statsLoading || apartmentsLoading) {
    return <PageLoader />;
  }

  return (
    <Stack gap="xl">
      <Title order={1}>Dashboard</Title>

      <SimpleGrid cols={{ base: 1, md: 3 }} spacing="md">
        <Paper
          p="lg"
          radius="md"
          withBorder
          style={{ borderColor: "#0f3460", textAlign: "center" }}
        >
          <Text size="2.5rem" fw={700} c="primary" mb="xs">
            {stats?.total_apartments || 0}
          </Text>
          <Text c="dimmed">Total Apartments</Text>
        </Paper>
        <Paper
          p="lg"
          radius="md"
          withBorder
          style={{ borderColor: "#0f3460", textAlign: "center" }}
        >
          <Text size="2.5rem" fw={700} c="green" mb="xs">
            {stats?.new_apartments || 0}
          </Text>
          <Text c="dimmed">New Apartments</Text>
        </Paper>
        <Paper
          p="lg"
          radius="md"
          withBorder
          style={{ borderColor: "#0f3460", textAlign: "center" }}
        >
          <Text size="2.5rem" fw={700} c="orange" mb="xs">
            {stats?.active_filters || 0}
          </Text>
          <Text c="dimmed">Active Filters</Text>
        </Paper>
      </SimpleGrid>

      <Paper p="md" radius="md" withBorder style={{ borderColor: "#0f3460" }}>
        <Group justify="space-between" mb="md">
          <Title order={3}>Recent Apartments</Title>
          <Anchor
            component={Link}
            to="/apartments"
            search={{ status: undefined }}
            c="primary"
            size="sm"
          >
            View all
          </Anchor>
        </Group>
        {apartmentsData?.items && apartmentsData.items.length > 0 ? (
          <ApartmentGrid apartments={apartmentsData.items} />
        ) : (
          <Center py="xl">
            <Text c="dimmed">No apartments found yet. The scraper will find some soon!</Text>
          </Center>
        )}
      </Paper>
    </Stack>
  );
}
